import map from 'lodash/map'
import { Dropdown } from 'react-bootstrap'
import { Field, FormModal } from '@ztechapps/webui.form'
import { TagsInput } from '@ztechapps/webui.input'
import { Alert } from '@ztechapps/webui.util'
import { useConversationInboxContext } from './Context'
import { useConversationBatchActions } from './useConversationBatchActions'

type BatchTagsFormValues = { tags: string[] }
const initialValues: BatchTagsFormValues = { tags: [] }

export const BatchTagsModal = () => {
  const { chatListWithSelection } = useConversationInboxContext()
  const { selectedList } = chatListWithSelection
  const { updateTags } = useConversationBatchActions()

  const onSubmit = async (values: BatchTagsFormValues) => {
    await updateTags(map(selectedList, '_id'), values.tags)
  }

  return (
    <FormModal<BatchTagsFormValues>
      trigger={({ onClick }) => <Dropdown.Item onClick={onClick}>Set tags</Dropdown.Item>}
      initialValues={initialValues}
      onSubmit={onSubmit}
      title="Set tags"
      saveText="Set tags"
      saveCancelButtonsProps={{ saveTitle: 'Set tags', cancelTitle: 'Cancel without changing tags' }}
    >
      <Field
        name="tags"
        label="Tags"
        component={TagsInput}
        onChange
        help="Replaces the tag list on every selected conversation. An empty list clears the tags."
        showHelpAsInline
      />
      <Alert type="info">
        Applies to <b>{selectedList.length}</b> selected conversation(s).
      </Alert>
    </FormModal>
  )
}
